module.exports = __webpack_public_path__ + "static/content-magento-3-6fa6189688b6a36c5eae57577e2e9237.jpg";